import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable, of } from 'rxjs';
import { map, catchError, tap, switchMap, filter, take } from 'rxjs/operators';
import { FetchLoggedInUser, LoginSuccess } from './+state/auth.actions';
import { select, Store } from '@ngrx/store';
import { getLoggedInUser } from './+state/auth.selectors';
@Injectable({
  providedIn: 'root',
})
export class LoginGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    private store: Store<any>,
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const token = route.queryParams.token;
    const resetPassword = route.queryParams.resetPassword;

    if (resetPassword) {
      return of(true);
    }

    if (token) {
      return this.authService.activate(token).pipe(
        tap((r) => this.store.dispatch(new LoginSuccess(r))),
        switchMap(() => this.performLoggedInLogic()),
        catchError(() =>
          of(this.router.createUrlTree(['/account/verification'])),
        ),
      );
    }

    return this.performLoggedInLogic();
  }

  private performLoggedInLogic(): Observable<boolean | UrlTree> {
    this.store.dispatch(new FetchLoggedInUser());

    return this.store.pipe(
      select(getLoggedInUser),
      filter((u) => u.initialState === false),
      take(1),
      map((user) => (user.id !== -1 ? this.router.createUrlTree(['/']) : true)),
    );
  }
}
